import { publicClient, privateClient } from './client';
import { Configuration } from './Configuration';

const transactionsConfiguration = (pub: boolean) => new Configuration(pub ? publicClient : privateClient);
export default transactionsConfiguration;
